import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-banner-demo',
  templateUrl: './banner-demo.component.html',
  styleUrls: ['./banner-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerDemoComponent {
  test(): void {}
}
